import React from "react";
import { Toast } from "antd-mobile";
import { post } from "../../utils/request";

import "./index.less";

class bindCehicleActivity extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
            detailData: {},
            status: false,
        };
    }

    // #/bindCehicleActivity?app_stoken=1111&phoneNumber=13333333333
    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
            // if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
            //     Toast.fail('请登录APP再进行操作',999);
            //     return;
            // }

            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    // if(ops.app_stoken && ops.app_stoken != 'null'){
                    //     this.getInviteTop();
                    // }
                }
            );
        }

        this.appShare(1, {
            title: `5元无门槛充电券免费领`,
            url: `${window.location.origin}/h5Static/#/bindCehicleActivity?source=wx`,
            cotent: "绑车福利限时抢  领券充电更优惠",
            img: "https://static.hellogil.com/oss-prod-unsafe-group/statics/783a7f10f1a74901bee0ec6897d203a4.png",
        });
    }

    viewPort = () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf("micromessenger") > -1,
            isQQ: u.indexOf("qq/") > -1,
            trident: u.indexOf("trident") > -1, //IE内核
            presto: u.indexOf("presto") > -1, //opera内核
            webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("ipad") > -1, //是否iPad
            webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
        };
    };

    appShare(type, ops, shareType) {
        let viewPort = this.viewPort();
        if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
            if (window.webkit) {
                if (type == "1") {
                    window.webkit.messageHandlers.showShare.postMessage(ops);
                } else {
                    window.webkit.messageHandlers.linkCarBind.postMessage({
                        url: "",
                    });
                }
            }
        } else {
            if (window.huilian) {
                if (type == "1") {
                    window.huilian.showShareWeixin(
                        ops.url,
                        ops.title,
                        ops.cotent,
                        ops.img
                    );
                } else {
                    window.huilian.linkCarBind();
                }
            }
        }
    }

    getActivity() {
        post({
            url: "/gateway/huilianOperation/hoActivityManagementcs/free/checkActivityEnable",
            // headers: {
            //     'Content-Type': 'application/json',
            // },
            data: { activityCode: "olpc202207120001" },
        }).then((res) => {
            if (res.result === "success") {
                if (res.data) {
                    this.appShare();
                } else {
                    Toast.info("活动已失效！", 1);
                }
            }
        });
    }

    render() {
        const { urlOps, detailData, status } = this.state;
        return (
            <div className="bindCehicleActivityBox">
                <div
                    className="reward_3_row"
                    onClick={() => {
                        if (urlOps.source && urlOps.source === "wx") {
                            window.location.href =
                                "https://www.hellogil.com/appDownload/#/HuilianDownload";
                        } else {
                            this.getActivity();
                        }
                    }}
                ></div>
            </div>
        );
    }
}

export default bindCehicleActivity;



// WEBPACK FOOTER //
// ./src/staticPage/bindCehicleActivity/index.js